// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://gyyymdcqtmqsdltfrqyi.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd5eXltZGNxdG1xc2RsdGZycXlpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc3OTgzNDgsImV4cCI6MjA3MzM3NDM0OH0.CTGsjMWo8D3t7bu2Xf_h5rV3JiRcSUU97bJHaRvfoXM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});